import React, { useEffect, useState } from "react";
import PageBar from "../../components/dashboard/page-bar/PageBar";
import Companies from "../../components/companies/Companies";
import axios from "axios";
import { Loaders } from "../Loaders";

const CompaniesPage = () => {
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState();

  const [count, setCount] = useState(10)
  const [page, setPage] = useState(1)

  const [initialVlue, setInitialVlue] = useState({
    search: '',
  })
  const handleChange = (e) => {
    const clone = { ...initialVlue }
    const value = e.target.value
    const name = e.target.name
    clone[name] = value
    setInitialVlue(clone)
  }

  const getCompanys = async (page) => {
    setLoader(true)
    const clone = { ...initialVlue, page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/company/all?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res.data);
      setLoader(false)
    } catch (error) {
      setLoader(false)
      alert("Error");
    }
  };
  const reset = async (page) => {
    setLoader(true)
    const clone = { search: '', page: page, count: count }
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/company/all?count=${clone?.count}&page=${clone?.page}&search=${clone?.search}`
      );
      setData(res?.data);
      setInitialVlue({
        search: '',
      })
      setLoader(false)
    } catch (error) { setLoader(false) }
  }
  const getCompanys2 = async (page) => {
    try {
      const res = await axios.get(
        `https://abarishr.hennainternational.in/api/company/all`
      );
      setData(res.data);
    } catch (error) {
      alert("Error");
    }
  };

  useEffect(() => {
    getCompanys(1);
  }, []);

  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(
        `https://abarishr.hennainternational.in/api/company/delete/${id}`
      );
      getCompanys(1)
    } catch (error) {
      alert("Error");
    }
  };
  const onChangeVal = (e) => {
    getCompanys(e)
  };
  return (
    <>
      {loader && <Loaders />}
      <div className="pageWrapper">
        <PageBar title="Companies" />
        <h3 className="page-title">
          Manage Companies
        </h3>
        <Companies data={data} handleDelete={handleDelete} getCompanys={getCompanys} onChangeVal={onChangeVal} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
      </div>
    </>
  );
};

export default CompaniesPage;
